module.exports = __webpack_public_path__ + "static/media/4.c1ed9a31.jpg";